<template>
    <div>
        <div class="center" :class="$style.title">
            <logo></logo>
        </div>
        <div :class="$style.content">
            <h1 class="center fs32">Terms and Conditionals</h1>
            <div>
                <h2 :class="$style.fs">Terms and conditions</h2>
            </div>
            <div>
                <h2 :class="$style.fs">Accounts and membership</h2>
                <p>If you create an account on the Website, you are responsible for maintaing the security of your account and you are fully responsible for all activities that occur under the account and any other actions taken in connection with it. We may monitor and review new accounts befor you may sign in and use our Serivces. Providing false contact information of any kind may result in the termination of your account. You must immediately notify us of any unauthorized uses of your account or any other breaaches of security. We will not be liable for any acts or omissions by you, including any damages of any kind incurred as a result of suct acts or omissions. We may suspend, disable, or delete your account( or any part thereof) if we determine that you have violated any provision of this Agreement or that your conduct or content would tend to damage our reputation and goodwill. If we delete your account for the foregoing reasons, you may not re-register for our Services. We may block your email address and IOnternet protocal address to prevent further registration.</p>
            </div>
            <div>
                <h2 :class="$style.fs">Backups</h2>
                <p>We are not responsible for Content residing on the Website. In no event shall we be held liable for any loss of any Content. It is your sole responsibility to maintain appropriate backup of your Content. Notwithstanding the foregoing, on some occasions and in certain circumstances, with absolutely no obligation, we may be able to restore some or all of your data that has been deleted as of a certain date and time when we may have backed up data for our own purposes. We make no guarantee that the data you need will be available.</p>
            </div>
            <div>
                <h2 :class="$style.fs">Links to other websites</h2>
                <p>Although this Website may link to other websites, we are not, directly or indirectly, implying any approval, association, sponsorship, endorsement, or affiliation with any linked website, unless specifically stated herein. Some of the links on the Website may be "affiliate links". This means if you click on the link and purchase an item, Website Operator will receive an affiliate commision. We are not responsible for examining or evaluating, and we do not warrant the offerings of, any businesses or individuals or the content of their websites. We do not assume any responsibility or liability for the actions, products, services, and content of any other third-parties. You should carefully review the legal statements and other conditions of use of any website which you access through a link from this Website. Your linking to any other off-site websites is at your own risk.</p>
            </div>
            <div>
                <h2 :class="$style.fs">Indemnification</h2>
                <p>You agree to indemnify and hold Website Operator and its affiliates, directors, officers, employees, and agents harmless from and against any liabilities, losses, damages or costs, including reasonable attorneys' fees, incurred in connection with or arising from any third-party allegations, claims actions, disputes, or demainds asserted against any of them as a result of or relating to your Content, you use of the Website or Services or any willful misconduct on your part.</p>
            </div>
            <div>
                <h2 :class="$style.fs">Serverability</h2>
                <p>All rights and restrictions contained in this Agreement may be exercised and shall be applicable and binding only to the extent that they do not violate any applicable laws and are intended to be limited to the extent necessary so that they will not render this Agreement illegal, invalid or unenforceable. If any provision or portion of any provision of this Agreement shall be held to be illegal, invalid or unenforceable by a court of competent jurisdiction, it is the intention of the parties that the remaining provisions or portions thereof shall constitute their agreement with respect to the subject matter hereof, and all such remaining provisions or portions thereof shall remain in full force and effect.</p>
            </div>
            <div>
                <h2 :class="$style.fs">Changes and amendments</h2>
                <p>We reserve the right to modify this Agreement or its policies relating to the Website or Services at any time, effective upon posting of an updated version of this Agreement on the Website. When we do, we wiill revise the updated date at the bottom of this page. Continued use of the Website after any such changes shall constitute your consent to such changes. Policy was created with WebsitePolicies.</p>
            </div>
            <div>
                <h2 :class="$style.fs">Acceptance of these Terms</h2>
                <p>You acknowledge that you have read this Agreement and agree to all its terms and conditions. By using the Website or its Services you agree to be bound by this Agreement. If you do not agree to abide by the terms of this Agreement, you are not authorized to use or access the Website and its Services.</p>
            </div>
            <div>
                <h2 :class="$style.fs">Contacting us</h2>
                <p>If you would like to contact us to understand more about this Agreement or wish to contact us concerning any matter relating to it, you may send an email to goldenwin3063@gmail.com</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'TermCondition',
    created() {
        this.$top();
    }
}
</script>
<style module>
.content {
    margin: 100px auto;
    width: 70%;
}
.content > div {
    margin-top: 40px;
}
.title {
    margin: 100px;
}
@media screen and (max-width: 770px) {
    .title {
        margin: 30px auto;
    }
    .content {
        margin: 0px 0px 30px 0px;
        padding: 0px 30px;
        width: 100%;
    }
    .content > div {
        margin-top: 30px;
    }
    .fs {
        font-size: 16px;
    }
}
</style>
